import config from "@/config";
import { useParams } from "react-router-dom";

export const useCompanyContext = () => {
  const { company } = useParams();
  if (!config.ACTIVATE_OLKYPASS_PRO)
    return {
      leUuid: null
    };
  return {
    leUuid: company ?? null
  };
};
